<template>
  <div class="page-err">
    <img @click="goBack" class="error-page-image" :src="IMG403" alt="403-image" />
    <el-button class="btn" size="medium" type="danger" @click="goBack">返回</el-button>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Page403 extends Vue {
  IMG403 = require('@/assets/403.png')

  goBack() {
    this.$router.go(-1)
  }
}
</script>

<style lang="scss" scoped>
  .page-err {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .error-page-image {
      width: 400px;
      height: auto;
    }

    .btn {
      margin-top: 20px;
    }
  }
</style>
